/*
  Asiri Blooms collection filters (Claude, Sept 2026).
  - Price: FiftyFlowers-style two-handle slider synced with $ min / $ max
    boxes. "Apply" (or Enter) writes the Search & Discovery price params into
    hidden inputs and fires the 'input' event theme.js already listens for, so
    results reload through the theme's own ajax filtering.
  - "Show All" expands lists longer than 10.
  - "Hide filters" / "Show filters" toggles the desktop sidebar.
  - Keeps the sticky sidebar clear of the fixed announcement bar + header.
  All handlers are delegated because theme.js replaces the sidebar markup on
  every filter change.
*/
(function () {
  if (window.__asiriFilters) return;
  window.__asiriFilters = true;

  function setStickyTop() {
    var header = document.querySelector('.site-header');
    var bar = document.querySelector('.announcement-bar--sticky');
    var top = (header ? header.offsetHeight : 0) + (bar ? bar.offsetHeight : 0) + 16;
    document.documentElement.style.setProperty('--asf-sticky-top', top + 'px');
  }

  function money(n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  }

  // gte / lte are strings in dollars ('' = no bound). Both empty clears the price.
  function applyPrice(form, label, gte, lte) {
    var state = form && form.querySelector('[data-asf-price-state]');
    if (!state) return;
    var min = state.querySelector('[data-asf-min]');
    var max = state.querySelector('[data-asf-max]');
    var clearing = !gte && !lte;

    // Nothing set and nothing to clear: don't reload for no reason.
    if (clearing && !state.classList.contains('tag--active')) return;

    min.value = gte || '';
    min.disabled = !gte;
    max.value = lte || '';
    max.disabled = !lte;

    // theme.js adds a "remove" chip for a newly active tag and just
    // un-highlights an active one; mark clearing as active so no chip appears.
    state.classList.toggle('tag--active', clearing);
    var text = state.querySelector('.tag__text');
    if (text) text.textContent = label;

    min.dispatchEvent(new Event('input', { bubbles: true }));
  }

  // ---------- Price slider ----------
  function parts(box) {
    return {
      min: parseFloat(box.getAttribute('data-min')) || 0,
      max: parseFloat(box.getAttribute('data-max')) || 0,
      rangeLo: box.querySelector('[data-asf-range-min]'),
      rangeHi: box.querySelector('[data-asf-range-max]'),
      boxLo: box.querySelector('[data-asf-price-min]'),
      boxHi: box.querySelector('[data-asf-price-max]'),
      track: box.querySelector('.asf-range')
    };
  }

  function clamp(v, lo, hi) {
    return Math.min(Math.max(v, lo), hi);
  }

  function readNumber(input, fallback) {
    var v = parseFloat(String(input.value).replace(/[^0-9.]/g, ''));
    return isFinite(v) ? v : fallback;
  }

  // Paints the black segment between the handles and keeps the lower handle
  // on top when both sit at the right end, so it can still be dragged.
  function paint(p) {
    var span = Math.max(p.max - p.min, 1);
    var lo = parseFloat(p.rangeLo.value);
    var hi = parseFloat(p.rangeHi.value);
    p.track.style.setProperty('--lo', ((lo - p.min) / span) * 100 + '%');
    p.track.style.setProperty('--hi', ((hi - p.min) / span) * 100 + '%');
    p.rangeLo.style.zIndex = lo >= p.max - span * 0.05 ? '3' : '2';
    p.rangeHi.style.zIndex = '2';
  }

  function onRange(input) {
    var box = input.closest('[data-asf-price]');
    if (!box) return;
    var p = parts(box);
    var lo = parseFloat(p.rangeLo.value);
    var hi = parseFloat(p.rangeHi.value);
    if (input === p.rangeLo && lo > hi) p.rangeLo.value = lo = hi;
    if (input === p.rangeHi && hi < lo) p.rangeHi.value = hi = lo;
    p.boxLo.value = lo;
    p.boxHi.value = hi;
    paint(p);
  }

  function onBox(input) {
    var box = input.closest('[data-asf-price]');
    if (!box) return;
    var p = parts(box);
    var lo = clamp(readNumber(p.boxLo, p.min), p.min, p.max);
    var hi = clamp(readNumber(p.boxHi, p.max), p.min, p.max);
    p.rangeLo.value = Math.min(lo, hi);
    p.rangeHi.value = Math.max(lo, hi);
    paint(p);
  }

  function applyBox(box) {
    if (!box) return;
    var p = parts(box);
    var lo = clamp(readNumber(p.boxLo, p.min), p.min, p.max);
    var hi = clamp(readNumber(p.boxHi, p.max), p.min, p.max);
    if (lo > hi) {
      var t = lo;
      lo = hi;
      hi = t;
    }
    // A handle left at the end of the range means "no limit" on that side.
    var gte = lo > p.min ? String(lo) : '';
    var lte = hi < p.max ? String(hi) : '';
    var label;
    if (gte && lte) label = money(lo) + ' – ' + money(hi);
    else if (gte) label = money(lo) + '+';
    else if (lte) label = 'Up to ' + money(hi);
    else label = 'Price';
    applyPrice(box.closest('form'), label, gte, lte);
  }

  // ---------- Hide / show filters ----------
  // The class lives on .collection-content / .search-content, outside the
  // markup theme.js swaps on each filter change, so it survives.
  function syncToggle() {
    var root = document.querySelector('.collection-content, .search-content');
    if (!root) return;
    var hidden = root.classList.contains('asf-filters-hidden');
    document.querySelectorAll('[data-asf-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', hidden ? 'false' : 'true');
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var toggle = event.target.closest('[data-asf-toggle]');
    if (toggle) {
      var root = toggle.closest('.collection-content, .search-content');
      if (!root) return;
      root.classList.toggle('asf-filters-hidden');
      syncToggle();
      return;
    }

    var apply = event.target.closest('.asf-price-apply');
    if (apply) {
      event.preventDefault();
      applyBox(apply.closest('[data-asf-price]'));
      return;
    }

    var more = event.target.closest('.asf-show-all');
    if (more) {
      event.preventDefault();
      var group = more.closest('.asf-group');
      var open = group.classList.toggle('asf-expanded');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = more.querySelector('.asf-show-all__text');
      if (label) label.textContent = open ? 'Show Less' : 'Show All';
      var content = more.closest('.collapsible-content');
      if (content && content.style.height && content.style.height !== 'auto') content.style.height = 'auto';
    }
  });

  // Moving the slider or typing a price must not trigger theme.js's
  // reload-on-input (or close the mobile drawer); only Apply / Enter does.
  document.addEventListener('input', function (event) {
    var el = event.target;
    if (!el.classList || !el.classList.contains('asf-price-input')) return;
    event.stopPropagation();
    if (el.type === 'range') onRange(el);
    else onBox(el);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('.asf-price-input');
    if (!input) return;
    event.preventDefault();
    applyBox(input.closest('[data-asf-price]'));
  });

  // The header shrinks once it sticks, so re-measure on scroll (once per frame).
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      setStickyTop();
    });
  }

  function paintAll() {
    document.querySelectorAll('[data-asf-price]').forEach(function (box) {
      paint(parts(box));
    });
  }

  syncToggle();
  paintAll();
  document.addEventListener('collection:reloaded', function () {
    syncToggle();
    paintAll();
  });

  setStickyTop();
  window.addEventListener('resize', setStickyTop);
  window.addEventListener('load', setStickyTop);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
